/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

const NON_EXPANDING_WIDTH = 2;
const NON_SHRINKING_WIDTH = 4;
const NON_SCALING_DOT_AND_DASH = 8;

const DOTTED = 16;
const DOTTED_DENSELY = 32;
const DOTTED_LOOSELY = 64;

const DASHED = 128;
const DASHED_DENSELY = 256;
const DASHED_LOOSELY = 512;

export const EShapeStrokeStyle = {
	NONE: 0,

	NON_EXPANDING_WIDTH,
	NON_SHRINKING_WIDTH,
	NON_SCALING_DOT_AND_DASH,
	NON_SCALING: NON_EXPANDING_WIDTH | NON_SHRINKING_WIDTH | NON_SCALING_DOT_AND_DASH,
	NON_SCALING_MASK: NON_EXPANDING_WIDTH | NON_SHRINKING_WIDTH | NON_SCALING_DOT_AND_DASH,

	DOTTED,
	DOTTED_DENSELY,
	DOTTED_LOOSELY,
	DOTTED_MASK: DOTTED | DOTTED_DENSELY | DOTTED_LOOSELY,

	DASHED,
	DASHED_DENSELY,
	DASHED_LOOSELY,
	DASHED_MASK: DASHED | DASHED_DENSELY | DASHED_LOOSELY
} as const;

export type EShapeStrokeStyle = number;
